import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import Config from '../../config'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
	storage: window.localStorage
})

export default new Vuex.Store({
	state: {
		auth: null,
		orderId: null,
		backdateOrderId: null,
		copyBarcode: null,
		doublePrint: true,
		logo: 'bd',
		customer: null,
		serverSetting: Config.serverUrl
	},

	mutations: {
		SET_AUTH: function(state, value) {
			state.auth = value
		},
		SET_ORDER_ID: function(state, value) {
			state.orderId = value
		},
		SET_BACKDATE_ORDER_ID: function(state, value) {
			state.backdateOrderId = value
		},
		SET_COPY_BARCODE: function(state, value) {
			state.copyBarcode = value
		},
		DOUBLE_PRINT: function(state, value) {
			state.doublePrint = value
		},
		SERVER_SETTING: function(state, value) {
			state.serverSetting = value
		},
		SET_LOGO: function(state, value) {
			state.logo = value
		},
		SET_CUSTOMER: function(state, value) {
			state.customer = value
		}
	},

	actions: {
		// To save user auth
		set_auth: (context, value) => {
			context.commit('SET_AUTH', value)
		},
		// To save order ID
		set_order_id: (context, value) => {
			context.commit('SET_ORDER_ID', value)
		},
		// To save backdate order ID
		set_backdate_order_id: (context, value) => {
			context.commit('SET_BACKDATE_ORDER_ID', value)
		},
		// To save order ID
		set_copy_barcode: (context, value) => {
			context.commit('SET_COPY_BARCODE', value)
		},
		// To print twice setting
		set_double_print: (context, value) => {
			context.commit('DOUBLE_PRINT', value)
		},
		// To set server setting
		set_server_setting: (context, value) => {
			context.commit('SERVER_SETTING', value)
		},
		// To set logo
		set_logo: (context, value) => {
			context.commit('SET_LOGO', value)
		},
		// To set customer info
		set_customer: (context, value) => {
			context.commit('SET_CUSTOMER', value)
		}
	},
	modules: {},
	plugins: [vuexLocal.plugin]
})
